import * as Yup from "yup";

export const vehicleSchema = Yup.object().shape({
  id: Yup.string()
    .max(25, "ID must be at most 25 characters")
    .required("ID is required"),
  transportationProviderId: Yup.string().required(
    "Transportation Provider ID is required"
  ),
  name: Yup.string().max(40, "Name must be at most 40 characters").optional(),
  make: Yup.string().max(40, "Make must be at most 40 characters").required("Make is required"),
  model: Yup.string().max(45, "Model must be at most 45 characters").optional(),
  color: Yup.string().max(10, "Color must be at most 10 characters").optional(),
  year: Yup.string().min(4, "Year must be at least 4 characters").max(4, "Year must be at most 4 characters").optional(),
  vin: Yup.string().max(17, "VIN must be at most 17 characters").required("VIN is required"),
  licensePlate: Yup.string().max(10, "License Plate must be at most 10 characters").required("License Plate is required"),
  licensePlateState: Yup.string()
    .max(10, "State must be 10 characters").optional(),
  credentialingStatus: Yup.string().optional(),
  // webhookURL: Yup.string().optional(),
});
